import React from "react";
import { Section } from "./primitives";
import { howIntro, steps } from "../mock/inferraData";
import SpreadPanel from "./panels/SpreadPanel";
import MemoPanel from "./panels/MemoPanel";
import ValidatePanel from "./panels/ValidatePanel";

const PANELS = {
  spread: SpreadPanel,
  memo: MemoPanel,
  validate: ValidatePanel,
};

export default function HowItWorks() {
  return (
    <Section id="how" bg="var(--pink)" pt={150} pb={40} style={{ overflow: "hidden" }}>
      <div className="how-intro" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 70 }}>
        <h2
          className="font-type reveal"
          style={{
            margin: 0,
            maxWidth: 620,
            fontSize: "clamp(32px, 4.4vw, 58px)",
            fontWeight: 700,
            lineHeight: 1.03,
            letterSpacing: "-1.2px",
          }}
        >
          {howIntro.heading}
        </h2>
        <p className="reveal d1" style={{ margin: 0, maxWidth: 460, fontSize: 17, lineHeight: 1.62, color: "var(--ink-soft)" }}>
          {howIntro.body}
        </p>
      </div>

      <div style={{ marginTop: 110, display: "flex", flexDirection: "column", gap: 120 }}>
        {steps.map((s, idx) => {
          const Panel = PANELS[s.id];
          return (
            <div key={s.id} className="step-row" style={{ display: "flex", gap: 70, alignItems: "flex-start" }}>
              <div className="step-left reveal" style={{ width: 340, flexShrink: 0 }}>
                <div className="font-type" style={{ fontSize: 40, fontWeight: 700, letterSpacing: "-1px", lineHeight: 1 }}>
                  {s.step}
                </div>
                <div style={{ marginTop: 12, fontSize: 15, lineHeight: 1.5, color: "var(--ink-soft)" }}>
                  {s.small}
                </div>
              </div>
              <div className="step-right reveal d1" style={{ flexGrow: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 14, color: "var(--green)", fontWeight: 600, marginBottom: 16 }}>
                  <span className="font-type" style={{ fontSize: 26 }}>{idx + 1}</span>
                  <span>{s.eyebrow}</span>
                </div>
                <h3
                  className="font-type"
                  style={{ margin: "0 0 16px", fontSize: "clamp(24px, 2.6vw, 36px)", fontWeight: 700, lineHeight: 1.14, letterSpacing: "-0.5px" }}
                >
                  {s.heading}
                </h3>
                <p style={{ margin: "0 0 30px", maxWidth: 560, fontSize: 16.5, lineHeight: 1.62, color: "var(--ink-soft)" }}>
                  {s.body}
                </p>
                <Panel />
              </div>
            </div>
          );
        })}
      </div>

      <style>{`
        @media (max-width: 980px) {
          .how-intro { flex-direction: column; align-items: flex-start; gap: 20px; }
          .step-row { flex-direction: column; gap: 26px; }
          .step-left { width: 100%; }
        }
      `}</style>
    </Section>
  );
}
